import {createAction, props} from '@ngrx/store';
import { Race } from '@app/rest-client/faxe/models/race';

const prefix = '[FAXE-RACE]';

export const fetchAllRaces = createAction(
  `${prefix} - fetch all`,
  props<{ issuerStack: string[] }>()
);

export const getRaces = createAction(
  `${prefix} - get`,
  props<{ issuerStack: string[] }>()
);

export const addManyRaces = createAction(
  `${prefix} - add many`,
  props<{ models: Race[]; issuerStack: string[] }>()
);
